import React from 'react';
import { Modal } from 'antd';
import Group from './Group';
import Icon from '../Icon';
import { bodyScrollFix } from '../../utils';

export default ({
  visible,
  onOk,
  initialItem,
  onAddToCart,
  releaseForm = true,
  ...rest
}) => (
  <Modal
    title={null}
    footer={null}
    open={visible}
    wrapClassName={'order'}
    width="100%"
    closeIcon={<Icon name="close" />}
    centered
    {...rest}
    afterClose={bodyScrollFix}
  >
    <Group
      initialItem={initialItem}
      addToCart={onAddToCart}
      releaseForm={releaseForm}
      closeModal={rest.onCancel}
    />
  </Modal>
);
